import React from 'react';
import './RecLabel.scss';

export const RecLabel = () => {
  return (
    <div className="rec-label">
      <span className="indicator" />
      <span className="text">Rec</span>
    </div>
  );
};
